var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 960",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 960) scale(1 -1)",
    d: "M479 152Q342 152 246.5 247.5Q151 343 151 480Q151 617 246.5 712.5Q342 808 479 808Q550 808 614.5 779Q679 750 725 695L725 766Q725 784 737 796Q749 808 767 808Q785 808 797 796Q809 784 809 766L809 562Q809 543 796 529.5Q783 516 764 516L559 516Q541 516 529 528.5Q517 541 517 558.5Q517 576 529 588Q541 600 559 600L684 600Q652 655 597.5 686Q543 717 479 717Q380 717 311 648Q242 579 242 480Q242 381 311 312Q380 243 479 243Q544 243 599 275.5Q654 308 685 363Q694 379 711 385Q728 391 745 385Q763 379 771 361.5Q779 344 770 329Q728 248 650.5 200Q573 152 479 152Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c93cba60736a5fc4526b07d99db141df.svg";
export { ForwardRef as ReactComponent };